import React, { useRef } from "react";
import Page from "./pageBlogNormal";
import CustomNavbar from "../../components/CustomNavbar";
import FooterData from "../../components/Footer/FooterData";
import FooterTwo from "../../components/Footer/FooterTwo";
// export const generateMetadata = ({ params }) => {
//   return {
//     title: `${params.serviceDetails}`,
//   };
// };

export const generateMetadata = ({ params }) => {
  return {
    title: "Explore Our Blog for Successful Learning | Grades Achievers",
    description:
      "Explore our Grades Achievers blog for insightful articles, expert tips, and inspiring stories on education. Stay informed and empowered with valuable resources .",
  };
};

function BPage() {
  const serviceRef = useRef(null);
  const onClickService = () => {
    serviceRef.current.scrollIntoView({ behavior: "smooth" });
  }
  return (
    <>
      <CustomNavbar
        nClass="m-auto"
        hbtnClass="new_btn"
      />
      <Page />
      <FooterTwo FooterData={FooterData} onClickService={onClickService} />
    </>
  );
}

export default BPage;
